import { createSlice } from '@reduxjs/toolkit';
import { CredentialsReducerState } from 'lib/types';

const initialState: CredentialsReducerState = {
    accountId: undefined,
    authToken: undefined,
    accessToken: undefined,
   /* userRoles: undefined*/
};

const credentialsSlice = createSlice({
    name: 'credentials',
    initialState,
    reducers: {
        setAccountId: (state, action) => {
            state.accountId = action.payload;
        },
        setAuthToken: (state, action) => {
            state.authToken = action.payload;
        },
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        //setUserRoles: (state, action) => {
        //    state.userRoles = action.payload;
        //}
    },
    extraReducers: {},
});

export default credentialsSlice.reducer;